import React from "react";
import { ROUTES } from "./constants";
import firebase from 'firebase/app';
import "firebase/auth";
import 'firebase/database';
import MessageList from "./MessageList";
import NewMessageForm from "./NewMessageForm";
import { ClipLoader } from 'react-spinners';
import ResponsiveSidebarView from './Responsive';

export default class MainView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: undefined,
            messagesSnap: undefined,
            messageChannel: 'general',
            isMobile: true,
        }
        this.handleSignOut = this.handleSignOut.bind(this)
    }
    componentDidMount() {
        this.unlistenAuth = firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.setState({ currentUser: user });
                let ref = firebase.database().ref(`/messages/${this.state.messageChannel}`);
                this.valueListener = ref.limitToLast(500).on('value', snapshot => this.setState({ messagesSnap: snapshot }));
                this.setState({ messagesRef: ref });
            } else {
                this.props.history.push(ROUTES.signIn)
            }
        });
    }

    componentWillUnmount() {
        this.state.messagesRef.off('value', this.valueListener);
        this.unlistenAuth();
    }

    componentWillReceiveProps(nextProps) {
        this.state.messagesRef.off('value', this.valueListener);
        let ref = firebase.database().ref(`/messages/${nextProps.match.params.chanName}`);
        this.valueListener = ref.limitToLast(500).on('value', snapshot => this.setState({ messagesSnap: snapshot }));
        this.setState({ messagesRef: ref });

    }
    handleSignOut() {
        firebase.auth().signOut();
        this.props.history.push(ROUTES.signIn);
    }
    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                <ResponsiveSidebarView 
                currentUser={this.state.currentUser}
                chanName={this.props.match.params.chanName}
                handleSignOut={this.handleSignOut}
                />
                    <div className="col mr-auto  col-md-9 col-lg-9 col-xl-9 pl-0 pr-0">
                        <div className="p-4 align-items-center">
                            <h4 className="text-secondary">#{this.props.match.params.chanName}</h4>
                        </div>
                        <div className="card rounded-0 border-left-0 p-2">
                            <div className="card-body pl-1 pr-1">
                              
                                {
                                    !this.state.messagesSnap
                                        ?
                                        <div className='sweet-loading'>
                                            <ClipLoader
                                                color={'#4d394b'}
                                                size={100}
                                                loading={this.state.loading}
                                            />
                                        </div>
                                        :
                                        <div>
                                            <MessageList messagesSnap={this.state.messagesSnap} messageChannel={this.state.messageChannel} authenticatedUser={this.state.currentUser} />
                                            <NewMessageForm messagesRef={this.state.messagesRef} messageChannel={this.state.messageChannel} user={this.state.currentUser} chanName={this.props.match.params.chanName} />
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Main.js